import * as React from "react";
const SvgFiBrandsMedium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M13.537 12c0 3.764-3.03 6.815-6.769 6.815C3.03 18.815 0 15.765 0 12c0-3.764 3.03-6.815 6.769-6.815 3.738 0 6.768 3.051 6.768 6.815M20.963 12c0 3.543-1.515 6.415-3.384 6.415S14.195 15.543 14.195 12s1.515-6.415 3.384-6.415S20.963 8.457 20.963 12M24 12c0 3.174-.533 5.748-1.19 5.748S21.62 15.175 21.62 12s.533-5.748 1.19-5.748S24 8.826 24 12"
    />
  </svg>
);
export default SvgFiBrandsMedium;
